export default __webpack_public_path__ + "static/media/soho_usage_tile_bg_dark.740b039b.png";